

import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace } from "vuex-class"

import vSelect from "vue-select"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import Comment from "@/components/CaseDetails/Comment.vue"
import UserImage from "@/components/UserImage.vue"
import SkeletonLoader from "@/components/SkeletonLoader.vue"
import { BModal } from "bootstrap-vue"
import { CaseAudit } from "@/types"

const caseStore = namespace("cases")

@Component({
	components: {
		"user-image": UserImage,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"comment": Comment,
		"loader": SkeletonLoader
	}
})
export default class CaseHistory extends Vue {
	$refs!: {
		caseHistory: BModal;
	}
	@caseStore.Getter("getCurrentCase") public currentCase: any;
	@caseStore.Getter("getCurrentCaseAudit") public auditHistory!: CaseAudit[] | null;

	@caseStore.Action("caseAuditLoad")
	private caseAuditLoad!: ({ lastUpdated }: { lastUpdated: string }) => Promise<void>;

	@caseStore.Action("caseAuditLoadAndAdd")
	private caseAuditLoadAndAdd!: ({ lastUpdated, currentAudit }: { lastUpdated: string, currentAudit: CaseAudit[] | null }) => Promise<void>;

	fetchingHistory: boolean = false

	@Prop({ type: Boolean, default: false })
	canCreateComments!: boolean;

	public async getCaseHistory (): Promise<void> {
		// Don't call if we are already in the process
		if (this.fetchingHistory) {
			return
		}

		this.fetchingHistory = true

		try {
			if (!this.auditHistory || this.auditHistory.length < 1) {
				// We need to get the whole history
				await this.caseAuditLoad({
					lastUpdated: this.currentCase.created.toString()
				})
			} else {
				// We need to update the existing history
				await this.caseAuditLoadAndAdd({
					lastUpdated: this.auditHistory[0].changedAt,
					currentAudit: this.auditHistory
				})
			}
		} finally {
			this.fetchingHistory = false
		}
	}

	public open (): void {
		this.$refs.caseHistory.show()
		this.getCaseHistory()
	}
}
